<template>
    <div class="boxs">
        <div class="seachBox flex" @keydown="searchKey">
            <div class="seachList" style="display: none;"><span class="name">客户名称：</span>
              <a-select
                  placeholder="请输入客户名称"
                  v-model="seach.a_customer_id" class="seachs"
                  :default-active-first-option="false"
                  :filter-option="false"
                  :not-found-content="null"
                  :options="options"
                  :show-arrow="false"
                  show-search
                  @change="handleChange"
                  @search="handleSearch"
              >
              </a-select>
<!--       @change="roomChange"          <a-select-->
<!--                        show-search-->
<!--                        option-filter-prop="children"-->
<!--                        :filter-option="filterOption"-->
<!--                        @change="handleChange"-->
<!--                        placeholder="请输入客户名称"-->
<!--                        v-model="seach.a_customer_id" class="seachs" allowClear-->
<!--                >-->
<!--                    <a-select-option :value="item.id" v-for="item in seachList.name">-->
<!--                        {{item.company}}-->
<!--                    </a-select-option>-->
<!--                </a-select>-->
            </div>
            <div class="seachList"><span class="name">tags：</span>
                <a-input placeholder="请输入tags" class="seachs" v-model="seach.name"/>
            </div>
            <div class="seachList">
              <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
                查询
            </a-button>
              <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button>
            </div>
            <div class="seachList no"></div>
        </div>
        <!-- <a-alert :message=message type="info"  v-if="!message==''" style="margin-bottom: 10px"/> -->
        <div style="margin-bottom: 12px">
<!--            <a-button class="top_btn" type="primary" @click="()=>{visible = true; title='批量翻译' ;this.editId=''; }">-->
<!--                批量翻译-->
<!--            </a-button>-->
            <a-button class="top_btn" type="primary" :disabled="!hasSelected" @click="()=>{  visibleForm = true; titleForm='批量翻译' }">
                批量翻译
            </a-button>
            <span style="margin-left: 8px">
              <template v-if="hasSelected">
                {{ `选中 ${product_ids.length} 项` }}
              </template>
            </span>
        </div>
        <a-table :columns="columns" :data-source="data" :pagination="pagination" rowKey="id" :loading="loadingtable"
                 :row-selection="{ selectedRowKeys: product_ids, onChange: onSelectChange }" v-if="data.length>0">
          <span slot="thumb" slot-scope="text, record"><img :src="record.thumb" alt="" style="width: 100%;display: block"></span>
          <span slot="category" slot-scope="text, record"><i v-for="(item,index) in record.category">{{ item }}</i></span>
        </a-table>
        <a-empty v-else  :description="description" />
        <NewForm :visible="visibleForm" :title="titleForm" :productids="product_ids" :customerid="seach.a_customer_id"
                 @changVisible=" () => { this.visibleForm = false;  this.getList(this.pageNum);this.getCustomerInfo()}  "/>
    </div>
</template>

<script>
import {debounce} from "../../../../utils/utils"
    import API from "../api";
    import NewForm from "./newForm"
    const columns = [
        {
            title: "tags",
            dataIndex: "name",
            ellipsis: true,
            key: "name",
            scopedSlots: {customRender: "name"}
        },
        {
            title: "更新日期",
            dataIndex: "update_time",
            ellipsis: true,
            key: "update_time",
            scopedSlots: {customRender: "update_time"}
        },
    ];
    export default {
        name: "translateAll",
        data() {
            return {
                pageNum:1,
                loadingtable:true,
                description:"请先选择客户",
                message:"",
                replaceFields: {children: 'children', title: 'name', key: 'id',value:"id"},
                visibleImg: false,
                tableImg: "",
                seachList: {
                    name: [],
                    class: []
                },
                seach: {
                  a_customer_id:undefined,
                  name: ""
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true,
                },
                data: [],
                columns,
                selectedRowKeys: [],
                visible: false,
                title: "",
                product_ids:[],
                visibleForm: false,
                titleForm: "",
                loading: true,
              options:[]
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/BatchTranslation/TranslationOther"; //设置左侧导航2-2 active
        },
        components: {NewForm},
        mounted() {
            // this.getSeachList()
        },
        computed: {
            hasSelected() {
                return this.product_ids.length > 0;
            },
        },
        methods: {
          // debounce(fn, time) {
          //   time = time || 200
          //   // 定时器
          //   let timer = null
          //   return function(...args) {
          //     var _this = this
          //     if (timer) {
          //       clearTimeout(timer)
          //     }
          //     timer = setTimeout(function() {
          //       timer = null
          //       fn.apply(_this, args)
          //     }, time)
          //   }
          // },


          handleSearch: debounce(function (val)   {
            this.handleSearchFn(val)
          }, 300),
            handleSearchFn(val){
            console.log(val)
            this.options=[];
            this.seachList.name=[]
            //下拉模糊查询
            if(val){this.getSeachList(val)}

            // console.log(res);
            // res.data.forEach((item) => {
            //   this.options.push({
            //     value: item.id,
            //     label: item.roomName,
            //   })
            // });
          },
            getSeachList(company){
                API.service.GET_NAME({company}).then(res => {
                    this.seachList.name = res.data.data
                    res.data.data.forEach((item) => {
                          this.options.push({
                            value: item.id,
                            label: item.company,
                          })
                        });
                })
            },
          getCustomerInfo(){
            API.service.GET_CUSTOMER_INFO( {id:this.seach.a_customer_id}).then(res => {
            this.message=`该公司购买字符${res.data.data.translation_set_num}个剩余字符${res.data.data.translation_surplus_num}个`
              // this.getSeachList()
            })
          },
            handleChange(value) {
                if(value==undefined)return
                this.loadingtable=true
                this.seachList.class=[]
                API.service.GET_CLASS({a_customer_id:value}).then(res => {
                    this.seachList.class = res.data.data
                })
                this.product_ids=[]
                this.seachList.name.forEach((item,index)=>{
                    if(item.id==value)this.message=`该公司购买字符${item.translation_set_num}个剩余字符${item.translation_surplus_num}个`
                })
                this.getList(1)
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            listOrder() {
                let list_orders = []
                let sortListOrder = {id: "", list_order: ""}
                for (let i = 0; i < this.data.length; i++) {
                    sortListOrder.id = this.data[i].id
                    sortListOrder.list_order = this.data[i].list_order
                    list_orders.push(sortListOrder)
                    sortListOrder = {}
                }
                API.service.LIST_ORDER(list_orders).then(res => {
                    this.getList(1)
                })
            },
            resetSeach() {
                this.loading = true
                this.message=""
                this.seach = {
                    a_customer_id: this.seach.a_customer_id,
                    name: ""
                }
                this.seachList.class= []
                this.data=[]
                this.getList(1,"reset")
                this.$emit("resetSeach");
            },
          searchKey(){
            if(event.keyCode == 13){
              this.getList(1)
            }
          },
            getList(page,type) {
              this.loadingtable=true
                let seachData = JSON.parse(JSON.stringify(this.seach))
                if(this.seach.a_customer_id==undefined&&type!="reset"){
                    this.data=[]
                    this.message=""
                    this.description="请先选择客户"
                }
                API.service.GET_LIST({page: page || this.pageNum, ...seachData}).then(res => {
                    this.pageNum=page || this.pageNum
                    if(res.data.code==400 &&type!="reset"){
                        this.$message.destroy()
                        this.$message.error(res.data.msg)
                        return
                    }
                    if(res.data.data.data ){
                        this.data = res.data.data.data}else{ this.data=[]}
                    if(this.data.length>0){
                        this.pagination.total = res.data.data.total
                        this.pagination.pageSize = res.data.data.per_page
                        this.pagination.current = res.data.data.current_page
                    }else{
                        this.description="暂无数据"
                    }
                    this.product_ids=[]
                    this.loading=false
                    this.loadingtable=false
                })
            },
            onSelectChange(selectedRowKeys) {
                this.product_ids = selectedRowKeys;
            },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }

</style>
